import { Progress } from 'src/component/ui/progress'
import { Skeleton } from 'src/component/ui/skeleton'
import { cn } from 'src/lib/utils'
import React from 'react'

export interface SeriesCardProgressProps {
  completedCount: number | undefined
  totalCount: number | undefined
  isReady: boolean
  className?: string
}

export const SeriesCardProgress = ({
  completedCount,
  totalCount,
  isReady,
  className,
}: SeriesCardProgressProps): React.ReactElement => {
  if (!isReady) {
    return (
      <div className={cn('mt-3 space-y-2', className)}>
        <Skeleton className="h-4 w-40 bg-white/20" />
        <Skeleton className="h-1.5 w-full rounded-full bg-white/20" />
      </div>
    )
  }

  const done = completedCount ?? 0
  const total = totalCount ?? 0
  const percent = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0
  const classWord = total === 1 ? 'class' : 'classes'

  return (
    <div className={cn('mt-3 space-y-2', className)}>
      <p className="text-lg font-roboto-condensed-medium text-ivory tracking-wide">
        {done} of{' '}
        <span className="opacity-65 font-roboto-condensed-medium">
          {total} {classWord} done
        </span>
      </p>
      <Progress value={percent} aria-label={`${done} of ${total} classes completed`} />
    </div>
  )
}
